import Base from './Base';

export type StatsResponse = Record<StatsType, string>;

export interface StatsSummaryResponse {
    total: StatsResponse;
    dates: {
        [date: string]: StatsResponse;
    };
    documents: Array<{
        document: DocumentSnippet;
        stats: StatsResponse;
    }>;
}

export interface AuthorStatsSummaryQuery {
    days?: number;
}

export interface AttributionsStatsSummaryQuery {
    days?: number;
}

class Stats extends Base {
    authorSummary(authorId: string, query: AuthorStatsSummaryQuery = null, opts = null) {
        return this.getJSONWithSession<StatsSummaryResponse>(
            `/authors/${authorId}/stats`,
            query,
            opts,
        );
    }

    attributionsSummary(query: AttributionsStatsSummaryQuery = null, opts = null) {
        return this.getJSONWithSession('/attributions/summary', query, opts);
    }
}

export default Stats;
